<template>
  <div class="programcommen1">
    <div class="commenlive">
      <div class="zhanwei" v-show="commenPrograms[0] == 'none'">
        <!-- <img src="../../assets/noprogram@2x.png" alt=""> -->
      </div>
      <div class="live" v-show="commenPrograms[0] != 'none'" v-for="(item, index) in commenPrograms" :key="index" >
        <div class="img" @click="nextPage(item)">
          <img :src="item.image" alt="" class="programImg" />
          <!-- <img :src="item.category_name" alt="" class="categoryImg"> -->
          <!-- <div class="show-number">{{item.category_name}}</div> -->
          <div class="show-number">
            <div>
              <!-- <img v-if="item.show_spectators && item.liveSourceType == '4'" src="../../assets/live_audio.jpg" alt=""  class="liveImg1" /> -->
              <font>{{ item.show_period }} 期</font>
            </div>
            <div>
              <font class="liveTime" v-if="item.is_live != '1'">{{ item.live_time }}</font>
              <!-- <img src="../../assets/live@2x.png" alt="" class="liveImg" />
              <font>w</font> -->
            </div>
          </div>
          <div class="categoryName">
            <div>
              <img v-if="item.is_live == '1'" src="../../assets/type1.png" alt="" class="liveImg1"/>
              <img v-else src="../../assets/type2.png" alt="" class="liveImg1"/>
              <!-- <font>{{ item.show_spectators }}</font> -->
            </div>
            <div>
              <!-- <img src="../../assets/live@2x.png" alt="" class="liveImg" /> -->
              <font v-if="item.is_live == '1'">{{item.show_spectators}}<span v-if="item.show_spectators.length >= 5" style="font-size: 0.25rem;">w</span>人正在观看</font>
              <font v-else>{{item.show_spectators}}<span v-if="item.show_spectators.length >= 5" style="font-size: 0.25rem;">w</span>次播放</font>
            </div>
          </div>
        </div>
        <figcaption>
          <p class="liveName">
            {{ item.title }}
          </p>
          <p class="liveCaption">
            {{ item.topic }}
          </p>
          <!-- <p class="liveTime">{{ item.time | formatDate }}</p> -->
        </figcaption>
      </div>
    </div>
  </div>
</template>

<script>
// let baseurl="http://api.dev.cbct.cn/"
import { formatDate } from "../../../static/js/date.js";
export default {
  name: "programcommen1",
  props: ["commenPrograms"],
  data() {
    return {
      commenProgramData: "",
      //  commonMsg:this.$store.state.commonProgram
    };
  },
  filters: {
    formatDate(time) {
      // time=time.replace("");
      var date = new Date(time * 1000);
      return formatDate(date, "yyyy-MM-dd");
    },
    peopleNumber: function (n1) {
      if (n1 != "") {
        let strNum = "";
        if (n1.length >= 5) {
          strNum = parseFloat(n1 / 10000).toFixed(1);
        } else {
          strNum = n1;
        }
        return strNum;
      }
    },
  },
  methods: {
    nextPage:function(item){
      if (item.is_live=='0') {
        // console.log('回放');
         this.$router.push({
            name:'programRecorded',
            query:{
                 type:'1',
                 live_id:item.play_id,
                 isLive:item.is_live,
                 title:item.title
              }
        })
      }else if(item.is_live=='1'){
         this.$router.push({
            name:'programRecorded',
            query:{
                 type:'1',
                 live_id:item.number,
                 isLive:item.is_live,
                 title:item.title
              }
          //  path:'programRecorded?type=1&live_id='+number+'&isLive='+islive+'&title='+title
         })
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.programcommen1 {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 .24rem;
  /* border: solid 1px; */
}
.commenlive {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.commenlive .live {
  width: 3.4rem;
  margin-bottom: .16rem;
  border-radius: .16rem;
  background: white;
}
.live .img {
  width: 100%;
  height: 2.12rem;
  /* background: darkgoldenrod; */
  margin: 0;
  position: relative;
}
.live .categoryName {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  width: 100%;
  height: 0.4rem;
  padding: 0 0.16rem;
  line-height: 0.33rem;
  text-align: center;
  font-size: 0.22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  /* background:rgba(80, 191, 255, 1); */
  border-radius: 0.2rem 0.2rem 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(0deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.2) 100%);
}
.live .img .programImg {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
}
.show-number {
  position: absolute;
  /* border: solid 1px; */
  /* height: 0.22rem;
   line-height: 0.22rem; */
  box-sizing: border-box;
  width: 100%;
  bottom: 0.15rem;
  /* padding-left: 0.25rem; */
  font-size: 0.22rem;
  /* font-family:PingFang-SC-Bold; */
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  display: flex;
  justify-content: space-between;
  padding: 0 0.16rem;
}
.liveImg {
  width: 0.14rem;
  height: 0.17rem;
  margin-right: 0.12rem;
}
.liveImg1 {
  width: auto;
  height: .32rem;
  margin-right: 0.12rem;
  vertical-align: middle;
}

.live figcaption {
  box-sizing: border-box;
  width: 100%;
  display: inline-block;
  padding: 0 .26rem 0 .14rem;
  font-weight: 400;
  text-align: left;
}

.liveName {
  font-size: 0.3rem;
  color: rgba(51, 51, 51, 1);
  width: 100%;
  padding-top: 0.16rem;
  /* white-space:nowrap; 
  overflow:hidden;
  text-overflow:ellipsis; */
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: 600;
}
.liveCaption {
  padding: 0.25rem 0 0.1rem;
  font-size: 0.26rem;
  color: rgba(102, 102, 102, 1);
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.liveTime {
  font-size: 0.22rem;
  color: white;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 0.21rem;
}
.zhanwei {
  width: 3.24rem;
  margin: 0 auto;
  height: 2.6rem;
  margin-top: 1rem;
  background: url("../../assets/noprogram@2x.png");
  background-size: 100%;
}
.zhanwei img {
  width: 3.24rem;
}
</style>
